import { useQuery } from '@tanstack/react-query';
import { api } from '~/lib/api-client';
import { saveProposalKeys } from '~/lib/query-keys';

export type SaveProposalStatus = 'pending' | 'approved' | 'rejected';

export interface SaveProposalItem {
  text: string;
  target: 'graph' | 'document';
}

export interface SaveProposal {
  id: number;
  sessionId: string;
  recap: string;
  items: SaveProposalItem[];
  status: SaveProposalStatus;
  createdAt: string;
  decidedAt?: string;
}

interface SaveProposalResponse {
  proposal: SaveProposal | null;
}

export function useSaveProposal(sessionId: string | undefined) {
  return useQuery({
    queryKey: sessionId ? saveProposalKeys.bySession(sessionId) : saveProposalKeys.all,
    queryFn: async () => {
      if (!sessionId) return null;
      const data = await api.get<SaveProposalResponse>(
        `/api/voice/save-proposal/current?sessionId=${encodeURIComponent(sessionId)}`,
      );
      return data.proposal;
    },
    enabled: !!sessionId,
    refetchInterval: (query) => {
      // Poll while the proposal is pending; stop once decided.
      const proposal = query.state.data;
      if (!proposal || proposal.status === 'pending') return 3000;
      return false;
    },
  });
}
